import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=23f12b9a&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=ts"
export * from "./TheNavbar.vue?vue&type=script&lang=ts"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=23f12b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f12b9a",
  null
  
)

export default component.exports